/*
--- 
description: FED Process
authors: 
- JF Simard
rework:
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.4.1: '*'
This class is a utility that makes a parent div clickable and uses the actual href of the first anchor child found
Accepts a collection of elements for each you want it to be applied
This is usefull when an entire zone needs to be clickable but without inserting a div inside an anchor which is NON standard markup.
...
*/

var Anchornator = new Class({
	Implements: Options,
	
	initialize: function(elements, options) {
		this._elements = elements || document.getElements('.anchornator');

		if(!this._elements || this._elements.length == 0) return;

		this.setOptions(options);
		this.build();
	},

	build: function(){
		var self = this;
		var _anchors, linked;

		this._elements.each(function(_el){
	 		_anchors = _el.getElements('a');

			if(!_anchors || _anchors.length == 0) return;

 			var href = _anchors[0].getAttribute('href');
 			var _blank = _anchors[0].getAttribute('target') == '_blank';
			
			if(href && href != '' && href.substr(0,1) != "#"){
				_el.addEvents({
					'click:relay(a)': function(e, _el){
						if(e && e.stop) e.stop();

						var url = _el.getAttribute('href');

						if(url && url != ''){
							linked = true;
							self.open_link(url, _el.getAttribute('target') == '_blank');
						}
					},

					'click': function(e){
						if(e && e.stop) e.stop();

						if(!linked){
							self.open_link(href, _blank);
						}

						linked = false;
					}
			 	});
			}
		});
	},

	open_link: function(url, is_blank){
		if(is_blank){
			var win = window.open(url, '_blank');
  		win.focus();
		}else{
			window.location = url;
		}
	}
});